import { getRequest, postRequest } from "../utils/axios";

export const toolsService = {
  listTools: (onSuccess, onError) =>
    getRequest("/api/v1/tools/", onSuccess, onError),
  listRuns: (tool, onSuccess, onError) => {
    const url = tool
      ? `/api/v1/tools/runs/?tool=${encodeURIComponent(tool)}`
      : "/api/v1/tools/runs/";
    return getRequest(url, onSuccess, onError);
  },
  getRun: (hash, onSuccess, onError) =>
    getRequest(`/api/v1/tools/runs/${hash}/`, onSuccess, onError),
  createRun: (tool, input, onSuccess, onError) =>
    postRequest("/api/v1/tools/runs/", { tool, input }, onSuccess, onError),
};
